export default __webpack_public_path__ + "static/indoor13-2f6b137d92d4e8b981e6e6121df9acd6.webp";